

// src/components/NewsFeedList.tsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import fetchData from '../Utilis/request';
import {Loader} from './Index';
import { HEADING_STYLE_DARK_MODE, HEADING_STYLE_LIGHT_MODE } from '../Config/config';

interface TickerItem {
  id: string;
  name: string;
  date_time: string;
}

interface NewsFeedListProps {
  darkMode?: boolean;
  fontSize?: string;
  limit?: number;
}

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const NewsTicker: React.FC<NewsFeedListProps> = ({ darkMode = false, fontSize = '', limit=50 }) => {
  const [newsItems, setNewsItems] = useState<TickerItem[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
    const [articleCount, setArticleCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {    
    const fetchNewsData = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await fetchData.getResult(`${API_BASE_URL}getTicker.php`);
        // console.log(response, " response getTicker")  
        if (response && Array.isArray(response?.tickers)) {
          setArticleCount(response?.tickers?.length);
          setNewsItems(response?.tickers);
        } else {
          setError("Invalid news data format received.");
          setNewsItems([]);
        }
      } catch (e) {
        console.error("Failed to fetch news data:", e);
        setError(e instanceof Error ? e.message : "An unknown error occurred while fetching news.");
        setNewsItems([]);
      } finally {
        setLoading(false);
      }
    };
    fetchNewsData();
  }, []);

  const handleClick = () => {
    navigate(`/bignews`); // Example: Navigate to a news detail page
  };

  const itemContainerClasses =`
    py-1 border-b last:border-b-0 cursor-pointer transition-colors duration-200
    ${darkMode ? 'border-gray-700 hover:bg-gray-700' : 'border-gray-200 hover:bg-gray-50'}
  `;

  const timeClasses = `
    font-bold text-sm
    ${darkMode ? 'text-gray-400' : 'text-gray-600'}
  `;

  const nameClasses = `
    text-base leading-snug
    ${darkMode ? 'text-gray-200' : 'text-gray-800'}
  `;

  if (loading) {
    return (
      <div className={`p-4 rounded-lg shadow-md ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>
       <Loader darkMode={darkMode}/>
      </div>
    );
  }

  if (error) {
    return (
      <div className={`p-4 rounded-lg shadow-md ${darkMode ? 'bg-gray-800' : 'bg-white'} ${darkMode ? 'text-red-400' : 'text-red-600'}`}>
        <p>Error: {error}</p>
      </div>
    );
  }

  if (newsItems.length === 0) {
    return (
      <div className={`p-4 rounded-lg shadow-md ${darkMode ? 'bg-gray-800' : 'bg-white'} ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
        <p>No latest updates available.</p>
      </div>
    );
  }

  return (
    <div className={`pt-2 rounded-lg shadow-md font-sans mb-5 ${darkMode ? 'bg-gray-900' +' '+ HEADING_STYLE_DARK_MODE : 'px-2 bg-white text-gray-900' +' '+ HEADING_STYLE_LIGHT_MODE}`}>
      

       <h2 className={`font-bold mb-0 ${fontSize === 'small' ? 'text-lg' : fontSize === 'large' ? 'text-2xl' : 'text-xl'}`}>
                      {"लाइव अपडेट"}
                    </h2>

      <div className="mt-0">
        {newsItems?.slice(0,limit).map((item: TickerItem) => (
          <div key={item.id} className={itemContainerClasses} onClick={() => handleClick()}>
            
            <div className={`${nameClasses}`}>{item.name}<p className={`${timeClasses} inline ml-2`}>{item.date_time}</p></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewsTicker;
